import { ChangeEvent, FC, Fragment, useEffect, useState } from "react";

// Components
import { Container, TabeContainer, TabeCart, Tbody } from "./style";
import NoDataFound from "components/particles/no-data-found";
import Button from "components/particles/primary-button";
import Pagination from "components/particles/pagination/pagination";

// Icons
import categoriesDarkIcon from "assets/images/categories-tab-dark-icon.svg";
import categoriesIcon from "assets/images/categories-tab-icon.svg";
import dietaryIcon from "assets/images/dietary-white-icon.svg";
import dietaryDarkIcon from "assets/images/diteryIcon.svg";
import link from "assets/images/link.svg";
import edit from "assets/images/edit.svg";
import view from "assets/images/view-icon.svg";

// Dto
import {
  DietariesDTO,
  dietarySearchDTO,
} from "utils/helpers/models/dietaries.dto";
import { set, useForm } from "react-hook-form";
import {
  categoriesSearchDTO,
  CategoryDTO,
} from "utils/helpers/models/categories.dto";

// Redux
import { useSelector } from "react-redux";
import { setCategoriesActiveButton, setModalOpened } from "store/user-slice";
import { dispatch } from "store";

// Popups
import AddCategoryModal from "components/popus/categories-popup/add-category";
import AddDietariesModal from "components/popus/dietaries-popup/add-dietaries";

// Categories Ingredients
import LinkedIngredientModal from "components/popus/categories-popup/linked-ingredient";
import SelectIngredientModel from "components/popus/categories-popup/select-ingredients";

// Dietary Ingredients
import DietariesLinkedIngredientModal from "components/popus/dietaries-popup/linked-ingredient";
import DietariesSelectIngredientModel from "components/popus/dietaries-popup/select-ingredients";

// Hook
import useCategories from "./useHook";
import { useSearchParams } from "react-router-dom";

const Categories: FC = () => {
  const [categoryPaginationState, setCategoryPaginationState] = useState<any>(
    {}
  );
  const [dietariesPaginationState, setDietariesPaginationState] = useState<any>(
    {}
  );
  const [categoryId, setCategoryId] = useState<number>(0);
  const [categoryName, setCategoryName] = useState<string>("");
  const [categoriesData, setCategoriesData] = useState<any[]>([]);
  const [categoriesDataById, setCategoriesDataById] = useState<any>();
  const [linkedIngredientData, setLinkedIngredientData] = useState<any[]>([]);
  const [linkedIngredientPagination, setLinkedIngredientPagination] =
    useState<any>({});
  const [selectIngredientData, setSelectedIngredientData] = useState<any[]>([]);
  const [status, setStatus] = useState<string>();
  const [dietaryId, setDietaryId] = useState<number>(0);
  const [dietaryName, setDietaryName] = useState<string>("");
  const [dietariesData, setDietariesData] = useState<any[]>([]);
  const [dietariesstatusData, setDietariesstatusData] = useState<any[]>([]);

  const [dietariesDataById, setDietariesDataById] = useState<any>();

  const [dietariesSelectIngredientData, setDietariesSelectedIngredientData] =
    useState<any[]>([]);
  const [dietaryLinkedData, setDietaryLinkedData] = useState<any[]>([]);
  const [dietariesStatus, setDietariesStatus] = useState<string>();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    categoriesActiveButton,
    addCategoriesModalIsOpen,
    addDietariesModalIsOpen,
    selectIngredientModalIsOpen,
    linkedIngredientModalIsOpen,
    dietariesSelectIngredientModalIsOpen,
    dietariesLinkedIngredientModalIsOpen,
    isLoading,
  } = useSelector((state: any) => state.user);

  const {
    getCategories,
    getDietaries,
    getUnLinkedCategoriesIngredients,
    getDietariesLinkedIngredientById,
    putCategoryById,
    putDietaries,
    getunLinkedDietariesIngredients,
    searchCategoriesIngredients,
    getCategoryLinkedIngredientById,
    searchDietaries,
    updateCategoryByStatus,
    updateCategoryDietary,
  } = useCategories();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset: formReset,
  } = useForm<any>();

  const limit = 10;

  // Function to refresh current data
  const refreshCurrentData = () => {
    if (categoriesActiveButton === "Categories") {
      const formData = getValues();
      if (formData.categoryName || formData.status) {
        searchCategories("search", formData);
      } else {
        getCategories(setCategoriesData, setCategoryPaginationState);
      }
    } else {
      const formData = getValues();
      if (formData.diateryName || formData.dietariesStatus) {
        dietariesSearch("search", formData);
      } else {
        getDietaries(setDietariesData, setDietariesPaginationState);
      }
    }
  };

  // Initialize data when component mounts
  useEffect(() => {
    if (categoriesActiveButton === "Categories") {
      getCategories(setCategoriesData, setCategoryPaginationState);
    } else {
      getDietaries(setDietariesData, setDietariesPaginationState);
    }
  }, []);

  // Handle tab switching - refresh data and reset pagination
  useEffect(() => {
    if (categoriesActiveButton === "Categories") {
      setValue("diateryName", "");
      setValue("dietariesStatus", "");
      setDietariesStatus("");
      // Reset categories pagination and fetch fresh data
      getCategories(setCategoriesData, setCategoryPaginationState);
    } else {
      setValue("categoryName", "");
      setValue("status", "");
      setStatus("");
      // Reset dietaries pagination and fetch fresh data
      getDietaries(setDietariesData, setDietariesPaginationState);
    }
  }, [categoriesActiveButton]);

  const searchCategories = (type: string, data: categoriesSearchDTO, offset = 0) => {
    const payload = {
      ...data,
      offset,
      limit,
    };

    // Update URL
    setSearchParams({
      categoryName: data.categoryName || "",
      status: data.status || ""
    });

    searchCategoriesIngredients(payload, setCategoriesData, setCategoryPaginationState);
  };

  const dietariesSearch = (type: string, data: dietarySearchDTO, offset = 0) => {
    const payload = {
      ...data,
      offset,
      limit,
    };

    // Update URL
    setSearchParams({
      diateryName: data.diateryName || "",
      dietariesStatus: data.dietariesStatus || ""
    });

    searchDietaries(payload, setDietariesData, setDietariesPaginationState);
  };

  const resetsearchCategories = () => {
    setStatus("");
    formReset({
      categoryName: "",
      status: ""
    });
    setSearchParams({});
    getCategories(setCategoriesData, setCategoryPaginationState);
  };

  const resetdietariesSearch = () => {
    setDietariesStatus("");
    formReset({
      diateryName: "",
      dietariesStatus: ""
    });
    setSearchParams({});
    getDietaries(setDietariesData, setDietariesPaginationState);
  };

  const addCategories = (id: number, data?: CategoryDTO) => {
    setCategoryId(id);
    dispatch(setModalOpened("Categories"));
    if (data) {
      setCategoriesDataById(data);
    }
  };

  const openIngredientPopupForLink = (id: number, name: string) => {
    setCategoryId(id);
    setCategoryName(name);
    dispatch(setModalOpened("Select Ingredient"));
    getUnLinkedCategoriesIngredients(setSelectedIngredientData);
  };

  const openIngredientPopupForUnLinked = (id: number, name: string) => {
    setCategoryId(id);
    setCategoryName(name);
    dispatch(setModalOpened("Linked Ingredient"));

    setLinkedIngredientData([]);
    setLinkedIngredientPagination({});
    getCategoryLinkedIngredientById(
      id,
      setLinkedIngredientData,
      setLinkedIngredientPagination,
      0,
      limit
    );
  };

  const openDietariesIngredientPopupForUnLink = (id: number, name: string) => {
    setDietaryId(id);
    setDietaryName(name);
    dispatch(setModalOpened("Dietaries Linked Ingredient"));
    setDietaryLinkedData([]);
    getDietariesLinkedIngredientById(id, (data: any[]) => {
      setDietaryLinkedData(data || []);
    });
  };

  const addDietaries = (id: number, data?: DietariesDTO) => {
    setDietaryId(id);
    dispatch(setModalOpened("Dietaries"));
    if (data) {
      setDietariesDataById(data);
    }
  };

  const openDietariesIngredientPopupForLink = (id: number, name: string) => {
    setDietaryId(id);
    setDietaryName(name);
    dispatch(setModalOpened("Dietaries Select Ingredient"));
    getunLinkedDietariesIngredients(id, setDietariesSelectedIngredientData);
  };

  function fetchNextRecords(offset: number) {
    const formData = getValues();

    if (categoriesActiveButton === "Categories") {
      // Check if there's an active search
      if (formData.categoryName || formData.status) {
        searchCategories("search", formData, offset);
      } else {
        getCategories(
          setCategoriesData,
          setCategoryPaginationState,
          offset,
          limit
        );
      }
    } else {
      // Check if there's an active search
      if (formData.diateryName || formData.dietariesStatus) {
        dietariesSearch("search", formData, offset);
      } else {
        getDietaries(
          setDietariesData,
          setDietariesPaginationState,
          offset,
          limit
        );
      }
    }

    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }

  // Fixed toggle status function for categories
  const toggleStatus = async (e: ChangeEvent<HTMLInputElement>, category: CategoryDTO, index: number) => {
    const newStatus = e.target.checked;
    
    // Create updated category with new status
    const updatedCategory = {
      ...category,
      status: newStatus
    };
    
    // Optimistically update the UI
    const updatedCategoriesData = [...categoriesData];
    updatedCategoriesData[index] = updatedCategory;
    setCategoriesData(updatedCategoriesData);
    
    try {
      // Update on server
      await updateCategoryByStatus(category?.id, updatedCategory);
    } catch (error) {
      // Revert on error
      console.error("Failed to update category status:", error);
      const revertedData = [...categoriesData];
      revertedData[index] = category; // Revert to original
      setCategoriesData(revertedData);
    }
  };

  // Fixed toggle status function for dietaries
  const toggleDietariesStatus = async (e: ChangeEvent<HTMLInputElement>, dietory: DietariesDTO, index: number) => {
    const newStatus = e.target.checked;
    
    // Create updated dietary with new status
    const updatedDietary = {
      ...dietory,
      status: newStatus
    };
    
    // Optimistically update the UI
    const updatedDietariesData = [...dietariesData];
    updatedDietariesData[index] = updatedDietary;
    setDietariesData(updatedDietariesData);
    
    try {
      // Update on server
      await updateCategoryDietary(dietory?.id, updatedDietary);
    } catch (error) {
      // Revert on error
      console.error("Failed to update dietary status:", error);
      const revertedData = [...dietariesData];
      revertedData[index] = dietory; // Revert to original
      setDietariesData(revertedData);
    }
  };

  const columns: string[] = [
    "Image",
    "Name",
    "No. of ingredients",
    "Status",
    "Actions",
  ];

  const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    setValue("status", newStatus);
  };
  
  const handleDietariesStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value;
    setDietariesStatus(newStatus);
    setValue("dietariesStatus", newStatus);
  };

  // Set initial active button
  useEffect(() => {
    dispatch(setCategoriesActiveButton("Categories"));
  }, []);

  // Handle URL parameters and initial search
  useEffect(() => {
    const categoryName = searchParams.get("categoryName") || "";
    const status = searchParams.get("status") || "";
    const diateryName = searchParams.get("diateryName") || "";
    const dietariesStatus = searchParams.get("dietariesStatus") || "";

    setValue("categoryName", categoryName);
    setValue("status", status);
    setValue("diateryName", diateryName);
    setValue("dietariesStatus", dietariesStatus);
    setStatus(status);
    setDietariesStatus(dietariesStatus);

    if (categoriesActiveButton === "Categories" && (categoryName || status)) {
      searchCategories("search", {
        categoryName,
        status,
        offset: 0,
        limit: 10,
      });
    } else if (categoriesActiveButton === "Dietary Preference" && (diateryName || dietariesStatus)) {
      dietariesSearch("search", { diateryName, dietariesStatus });
    }
  }, []);

  return (
    <>
      <Container>
        <div className="categories-title">
          <h1 id="toTop">Category Type</h1>
          <Button
            title={
              categoriesActiveButton === "Categories"
                ? "Add Category"
                : "Add Dietary Preference"
            }
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={
              categoriesActiveButton === "Categories"
                ? () => addCategories(0)
                : () => addDietaries(0)
            }
          />
        </div>

        <TabeContainer>
          <TabeCart
            active={categoriesActiveButton === "Categories"}
            onClick={() => {
              dispatch(setCategoriesActiveButton("Categories"));
            }}
          >
            <div className="categories-tab-img">
              <img
                src={
                  categoriesActiveButton === "Categories"
                    ? categoriesIcon
                    : categoriesDarkIcon
                }
                alt="img"
              />
            </div>
            <h1>Category</h1>
          </TabeCart>
          <TabeCart
            active={categoriesActiveButton === "Dietary Preference"}
            onClick={() => {
              dispatch(setCategoriesActiveButton("Dietary Preference"));
            }}
          >
            <div className="categories-tab-img">
              <img
                src={
                  categoriesActiveButton === "Dietary Preference"
                    ? dietaryIcon
                    : dietaryDarkIcon
                }
                alt="img"
              />
            </div>
            <h1>Dietary Preference</h1>
          </TabeCart>
        </TabeContainer>
        <div className="search-container">
          <div className="input-fields">
            {categoriesActiveButton === "Categories" ? (
              <>
                <input
                  type="text"
                  placeholder="Search By Name"
                  {...register("categoryName")}
                />
                <select
                  id="status"
                  {...register("status")}
                  value={status}
                  onChange={handleStatusChange}
                >
                  <option value="">Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Search By Name"
                  {...register("diateryName")}
                />
                <select
                  id="status"
                  {...register("dietariesStatus")}
                  value={dietariesStatus}
                  onChange={handleDietariesStatusChange}
                >
                  <option value="">Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </>
            )}
          </div>
          <div className="button-fields">
            <Button
              title="Search"
              width="16rem"
              fill="true"
              onclick={
                categoriesActiveButton === "Categories"
                  ? handleSubmit((data) => searchCategories("search", data))
                  : handleSubmit((data) => dietariesSearch("search", data))
              }
            />
            <Button
              title="Reset"
              width="16rem"
              fill="true"
              backgroundcolor="var(--reset-button)"
              onclick={
                categoriesActiveButton === "Categories"
                  ? handleSubmit(() => resetsearchCategories())
                  : handleSubmit(() => resetdietariesSearch())
              }
            />
          </div>
        </div>
        <div className="data-table">
          <table>
            <thead>
              <tr>
                {columns.map((column: string, index: number) => {
                  return (
                    <th scope="col" key={index}>
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <Tbody>
              {categoriesActiveButton === "Categories" ? (
                categoriesData?.length > 0 ? (
                  categoriesData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <img
                            src={
                              item?.image
                                ? item?.image
                                : "https://picsum.photos/300"
                            }
                            alt="img"
                            width={60}
                            height={60}
                            style={{ borderRadius: "50%" }}
                          />
                        </td>
                        <td>{item?.name}</td>
                        <td>{item?.ingredientsCount}</td>
                        <td>
                          <label className="toggle-button">
                            <input
                              type="checkbox"
                              checked={item?.status}
                              onChange={(e) => toggleStatus(e, item, index)}
                            />
                            <span className="slider round"></span>
                          </label>
                        </td>

                        <td className="actions">
                          <div style={{ display: "flex", gap: "1rem" }}>
                            <div
                              className="view-container"
                              onClick={() =>
                                openIngredientPopupForUnLinked(
                                  item?.id,
                                  item?.name
                                )
                              }
                            >
                              <img src={view} alt="img" />
                            </div>
                            <button
                              onClick={() =>
                                openIngredientPopupForLink(
                                  item?.id,
                                  item?.name
                                )
                              }
                              className="tooltip link-button"
                            >
                              <img src={link} alt="img" />
                              <span className="tooltiptext">
                                Link Ingredient
                              </span>
                            </button>
                            <div className="edit-container">
                              <img
                                src={edit}
                                alt="img"
                                onClick={() => addCategories(item.id, item)}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <NoDataFound isShow={!isLoading} />
                )
              ) : dietariesData?.length > 0 ? (
                dietariesData?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="flex gap-4 items-center">
                          <img
                            src={
                              item?.image
                                ? item?.image
                                : "https://picsum.photos/300"
                            }
                            alt="img"
                            width={60}
                            height={60}
                            style={{ borderRadius: "50%" }}
                          />
                        </div>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.ingredientsCount}</td>
                      <td>
                        <label className="toggle-button">
                          <input
                            type="checkbox"
                            checked={item?.status}
                            onChange={(e) => toggleDietariesStatus(e, item, index)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>

                      <td className="actions">
                        <div style={{ display: "flex", gap: "1rem" }}>
                          <div
                            className="view-container"
                            onClick={() =>
                              openDietariesIngredientPopupForUnLink(
                                item?.id,
                                item?.name
                              )
                            }
                          >
                            <img src={view} alt="img" />
                          </div>
                          <button
                            onClick={() =>
                              openDietariesIngredientPopupForLink(
                                item?.id,
                                item?.name
                              )
                            }
                            className="tooltip link-button"
                          >
                            <img src={link} alt="img" />
                            <span className="tooltiptext">Link Ingredient</span>
                          </button>
                          <div
                            className="edit-container"
                            onClick={() => addDietaries(item.id, item)}
                          >
                            <img src={edit} alt="img" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NoDataFound isShow={!isLoading} />
              )}
            </Tbody>
          </table>
        </div>
        <Fragment>
          <Pagination
            totalRecords={
              categoriesActiveButton === "Categories"
                ? categoryPaginationState?.total
                : dietariesPaginationState?.total
            }
            perPage={limit}
            handleFetchNextRecords={fetchNextRecords}
          />
        </Fragment>

        {addCategoriesModalIsOpen ? (
          <AddCategoryModal
            id={categoryId}
            data={categoriesDataById}
            categoriesData={categoriesData}
            setCategoriesData={setCategoriesData}
            searchCategories={searchCategories}
          />
        ) : (
          ""
        )}
        {selectIngredientModalIsOpen ? (
          <SelectIngredientModel 
            id={categoryId}
            name={categoryName}
            onRefresh={refreshCurrentData}
          />
        ) : (
          ""
        )}
        {linkedIngredientModalIsOpen ? (
          <LinkedIngredientModal
            id={categoryId}
            name={categoryName}
            data={linkedIngredientData}
            setData={setLinkedIngredientData}
            pagination={linkedIngredientPagination}
            setPagination={setLinkedIngredientPagination}
            limit={limit}
            onRefresh={refreshCurrentData}
          />
        ) : (
          ""
        )}
        {addDietariesModalIsOpen ? (
          <AddDietariesModal
            id={dietaryId}
            data={dietariesDataById}
            dietariesData={dietariesData}
            setDietariesData={setDietariesData}
            refreshData={refreshCurrentData}
          />
        ) : (
          ""
        )}
        {dietariesSelectIngredientModalIsOpen ? (
          <DietariesSelectIngredientModel
            id={dietaryId}
            name={dietaryName}
            data={dietariesSelectIngredientData}
            onRefresh={refreshCurrentData}
          />
        ) : (
          ""
        )}
        {dietariesLinkedIngredientModalIsOpen ? (
          <DietariesLinkedIngredientModal
            id={dietaryId}
            name={dietaryName}
            data={dietaryLinkedData}
            setData={setDietaryLinkedData}
            onRefresh={refreshCurrentData}
          />
        ) : (
          ""
        )}
      </Container>
    </>
  );
};

export default Categories;